import type React from "react"

/**
 * A custom element that sets `indeterminate = true` on its child
 * `<input>` element. This bridges the gap between HTML (which has no
 * `indeterminate` attribute) and the DOM property that CSS
 * `:indeterminate` reads from.
 *
 * Usage:
 *   <tds-indeterminate>
 *     <input type="checkbox" />
 *   </tds-indeterminate>
 */
if (typeof HTMLElement !== "undefined") {
  class TdsIndeterminate extends HTMLElement {
    #input: HTMLInputElement | null = null

    connectedCallback() {
      this.#input = this.querySelector("input")
      if (this.#input) this.#input.indeterminate = true
    }

    disconnectedCallback() {
      if (this.#input) this.#input.indeterminate = false
      this.#input = null
    }
  }

  if (!customElements.get("tds-indeterminate")) {
    customElements.define("tds-indeterminate", TdsIndeterminate)
  }
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "tds-indeterminate": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & { value?: string },
        HTMLElement
      >
    }
  }
}
